import { Metrics } from 'AdsUI/Metrics';
import { hasAcceptedGoogleECDataTerms } from 'AdsUI/lib/adAccounts'; // @ts-expect-error importing from JS file

import { OfflineEventTriggers } from 'AdsUI/lib/Constants'; // @ts-expect-error importing from JS file

import { usageTracker } from 'AdsUI/lib/usageTracker';

/**
 * Fetch fresh ad account data.
 * @param fetch The function used to fetch the accounts
 * @returns The fetched ad accounts
 */
export const fetchAdAccounts = async fetch => {
  try {
    const accounts = await fetch();
    return accounts;
  } catch (error) {
    return [];
  }
};
/**
 * Determine if the form has errors based on the user's inputs.
 * @param eventOptions
 * @param accountsWithoutBusinessManager
 * @returns True or false
 */

export const formHasErrors = (eventOptions, accountsWithoutBusinessManager) => {
  const {
    currentEventTrigger,
    selectedAdAccount
  } = eventOptions;

  if (!selectedAdAccount) {
    return true;
  }

  const {
    adAccount
  } = selectedAdAccount;

  if (!currentEventTrigger || !adAccount) {
    return true;
  }

  if (accountsWithoutBusinessManager.has(adAccount)) {
    return true;
  }

  const {
    selectedLifecycleStageId,
    selectedEventCategoryId,
    stageValue,
    currency,
    usedStageIds
  } = eventOptions;
  const isInvalidAdAccount = usedStageIds && usedStageIds.get(adAccount, []).indexOf(selectedLifecycleStageId) !== -1;

  if (isInvalidAdAccount) {
    return true;
  }

  return !selectedLifecycleStageId || !selectedEventCategoryId || !stageValue || !currency;
};
/**
 * Generate the data used to create a new event based on the given options.
 * @param validatedEventOptions The validate event options
 * @returns An event to send to the event creation API endpoint
 */

export const generateNewEventData = validatedEventOptions => {
  return {
    currencyCode: validatedEventOptions.currency,
    enabled: true,
    eventCategory: validatedEventOptions.selectedEventCategoryId,
    eventName: validatedEventOptions.name,
    eventTriggerType: OfflineEventTriggers.LIFECYCLE_STAGE_CHANGE,
    isEstimatedValue: validatedEventOptions.isEstimatedValue,
    isPrimaryForGoal: validatedEventOptions.isPrimaryForGoal,
    lifecycleStageId: validatedEventOptions.selectedLifecycleStageId,
    value: validatedEventOptions.stageValue
  };
};
/**
 * Record metrics for the submission of the given event.
 * @param network The ad network
 * @param event The new event
 */

export const recordSubmissionMetrics = (network, event) => {
  usageTracker.track('modifyEvent', {
    action: 'Created event',
    network,
    trigger: OfflineEventTriggers.LIFECYCLE_STAGE_CHANGE,
    usingDeals: event.isEstimatedValue,
    lifecycleStage: event.selectedLifecycleStageId,
    networkStage: event.selectedEventCategoryId
  });
  Metrics.counter('created-event', {
    network
  }).increment();
};
/**
 * Determine if the Google data terms were accepted.
 * @param fetchedAdAccounts Ad accounts that were just fetched
 * @param selectedAdAccountId The selected ad account's ID
 * @returns True or false
 */

export const validateDataTermsWereAccepted = (fetchedAdAccounts, selectedAdAccountId) => {
  const freshAccountInfo = fetchedAdAccounts.find(adAccount => adAccount.accountId === selectedAdAccountId);

  if (!freshAccountInfo) {
    return false;
  }

  return hasAcceptedGoogleECDataTerms(freshAccountInfo);
};